<template lang="pug">
  v-card.elevation-6.balance-card
    v-card-title.headline.justify-center.balance-card__title(:class="[labelbackcolor, {'balance-card__title--dark': labeltextdark }]") {{ labeltext }}
    v-divider
    v-card-text.pa-0
      p.text-center.pa-4.ma-0(v-if="items.length == 0") {{ translations.noResults }}
      v-simple-table.card__table(v-else)
        template(v-slot:default)
          tbody
            tr(v-for="(data,key) in items" :key="'row'+key")
              td.text-center {{ data.text }}
              td.text-right
                span.pr-10 {{ data.value }}
</template>

<script>
  export default {
    name: "BalanceCard",
    props:{
      labeltext:{
        type: String,
        default: 'title'
      },
      labelbackcolor:{
        type: String,
        default: 'grey lighten-1'
      },
      labeltextdark:{
        type: Boolean,
        default: false
      },
      items:{
        type: Array,
        default: function(){
          return []
        }
      },
    },
    computed: {
      translations() {
        return this.$t("components.balanceCard");
      },
    },
  }
</script>

<style lang="sass">
.balance-card
  &__title
    color: #fff
    &--dark
      color: rgba(0,0,0,0.87)
</style>